export function formatPhoneNumber(phoneNumber: string): string {
	const lastFourDigits = phoneNumber.slice(-4);
	return `x${lastFourDigits}`;
}